angular.module('picmonicng').filter('fallback', function () {
  return function (input, fallback) {
    return input === null || input === undefined ? fallback : input;
  };
});
